import * as React from 'react';

import styles from './Form.module.styl';
import Typography from '@material-ui/core/Typography';
import { Blinker } from './Blinker';
import { permissionsConfig } from './permissionsConfig';

export class FormLoader extends React.Component<any, any> {
  render() {
    const { config } = this.props;

    return (
      <div className={styles.root}>
        {typeof config.title === 'function' ? (
          <Blinker />
        ) : (
          <div className={styles.header}>
            <Typography className={styles.title} variant="h4" id="tableTitle">
              {config.title}
            </Typography>
          </div>
        )}
        {this.renderFields()}
        <div className={styles.loaderMessage}>Loading...</div>
      </div>
    );
  }

  private readonly renderFields = () => {
    return this.getFields().map((field: any | any[]) => {
      if (Array.isArray(field)) {
        return (
          <div className={styles.inlineFieldsWrapper} key={field[0].name}>
            {field.map((inlineField: any) => {
              return (
                <Blinker key={inlineField.name} title={inlineField.title} />
              );
            })}
          </div>
        );
      }
      return <Blinker key={field.name} title={field.title} />;
    });
  };

  private readonly getFields = () => {
    const { config } = this.props;

    const { fields, withPermission } = config;

    return withPermission ? [...fields, ...permissionsConfig] : fields;
  };
}
